<div class="wgu-container">
  <h2>Setup Your Account</h2>

  <div *ngIf="errorResponse && displayError" class="error-message my-3">
    <div class="error-message-left">
      <img
        alt="Error Message"
        class="img-responsive"
        src="/assets/images/landing/warning.png"
        width="56"
      />
    </div>

    <div class="error-message-middle">{{ errorResponse }}</div>

    <button (click)="closeDisplayError()" class="error-message-right">
      <img
        alt="Close Error Message"
        class="img-responsive"
        src="/assets/images/securityquestions/Close.png"
        width="16"
      />
    </button>
  </div>

  <div class="h1">Step 2: Help Us Identify You</div>

  <p class="mb-6">
    Please provide the following information. The first and last name fields are
    case-sensitive and must match your employee record. You should have received
    your claim code on a form that came with your WGU laptop or in an email to
    your personal email address. If you need further help, please contact the IT
    Service Desk at <a href="mailto:servicedesk@wgu.edu" target="_blank">servicedesk&#64;wgu.edu</a> or <a href="tel:(877) 435-7948" target="_blank">(877) 435-7948</a>.
  </p>
  <!--<div>
      <em>{{errorResponse}}</em>
 </div> -->

  <form
    #loginForm="ngForm"
    (ngSubmit)="login(loginForm.value)"
    autocomplete="off"
    novalidate
  >
    <div class="form-group">
      <label class="wgu-outlined general">
        <!--  *ngIf="errorResponse"    <em *ngIf="loginForm.controls.first_name?.invalid && (loginForm.controls.first_name?.touched || mouseoverLogin)">Required</em>-->
        <input
          [ngClass]="{
            error:
              loginForm.controls.first_name?.invalid &&
              (loginForm.controls.first_name?.touched || mouseoverLogin)
          }"
          (ngModel)="(first_name)"
          name="first_name"
          required
          id="first_name"
          type="text"
          class="form-control"
          placeholder="   "
        />
        <span
          [ngClass]="{
            error:
              loginForm.controls.first_name?.invalid &&
              (loginForm.controls.first_name?.touched || mouseoverLogin)
          }"
          >First Name</span
        >
        <p
          *ngIf="
            loginForm.controls.first_name?.invalid &&
            (loginForm.controls.first_name?.touched || mouseoverLogin)
          "
          class="error-label"
        >
          Required
        </p>
      </label>
    </div>

    <div class="form-group">
      <label class="wgu-outlined general">
        <!-- <em *ngIf="loginForm.controls.last_name?.invalid  && (loginForm.controls.last_name?.touched || mouseoverLogin)">Required</em>-->
        <input
          [ngClass]="{
            error:
              loginForm.controls.last_name?.invalid &&
              (loginForm.controls.last_name?.touched || mouseoverLogin)
          }"
          (ngModel)="(last_name)"
          name="last_name"
          required
          id="last_name"
          type="text"
          class="form-control"
          placeholder="   "
        />
        <span
          [ngClass]="{
            error:
              loginForm.controls.last_name?.invalid &&
              (loginForm.controls.last_name?.touched || mouseoverLogin)
          }"
          >Last Name</span
        >
        <p
          *ngIf="
            loginForm.controls.last_name?.invalid &&
            (loginForm.controls.last_name?.touched || mouseoverLogin)
          "
          class="error-label"
        >
          Required
        </p>
      </label>
    </div>

    <div class="form-group">
      <label class="wgu-outlined general">
        <!-- <em *ngIf="loginForm.controls.claim_code?.invalid && (loginForm.controls.claim_code?.touched || mouseoverLogin)">Required</em>-->
        <input
          [ngClass]="{
            error:
              loginForm.controls.claim_code?.invalid &&
              (loginForm.controls.claim_code?.touched || mouseoverLogin)
          }"
          (ngModel)="(claim_code)"
          name="claim_code"
          required
          id="claim_code"
          type="text"
          class="form-control"
          placeholder="   "
        />
        <span
          [ngClass]="{
            error:
              loginForm.controls.claim_code?.invalid &&
              (loginForm.controls.claim_code?.touched || mouseoverLogin)
          }"
          >Claim Code</span
        >
        <p
          *ngIf="
            loginForm.controls.claim_code?.invalid &&
            (loginForm.controls.claim_code?.touched || mouseoverLogin)
          "
          class="error-label"
        >
          Required
        </p>
      </label>
    </div>

    <!--https://www.concretepage.com/angular-2/angular-2-select-option-multiple-select-option-validation-example-using-template-driven-form-->

    <!--<em *ngIf="loginForm.controls.user_type?.invalid && (loginForm.controls.user_type?.touched || mouseoverLogin)">Required</em>
      <em *ngIf="loginForm.controls.user_type?.invalid && (loginForm.controls.user_type?.touched || mouseoverLogin)">Required</em>
     <div class="select">

      <select class="select-text" name="user_type" [(ngModel)]="user_type" required id="user_type" (change)="onUserTypeChange()">
        
        <option *ngFor="let usertype of allUserTypes" [ngValue]="usertype" >{{usertype.name}}</option>
      </select>
      <label class="select-label">User Type</label>
    </div>-->

    <div class="form-actions">
      <!--<span (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false">
      <button class="wgu-btn" type="submit" [disabled]="loginForm.invalid" class="wgu-btn">Next</button>
    </span>-->
      <button
        class="wgu-btn"
        type="submit"
        [disabled]="loginForm.invalid"
        class="wgu-btn"
      >
        Next
      </button>

      <a href="identityiq/external/cancelPage" class="wgu-btn-text">Cancel</a>
    </div>
  </form>
</div>
